"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Message = _interopRequireDefault(require("../../components/Message"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Container = _styledComponents.default.div.withConfig({
  displayName: "BooleanInputGroup__Container",
  componentId: "nftamj-0"
})(["margin-bottom:", ";> * + *{margin-bottom:", ";}"], (0, _rem.default)(-10), (0, _rem.default)(10));

var directionModifiers = function directionModifiers(_ref) {
  var isVertical = _ref.isVertical;
  return isVertical ? (0, _styledComponents.css)({
    flexDirection: 'column'
  }) : null;
};

var getItemsRightMargin = function getItemsRightMargin(_ref2) {
  var isVertical = _ref2.isVertical;
  return (0, _rem.default)(isVertical ? 0 : 20);
};

var ItemsContainer = _styledComponents.default.div.withConfig({
  displayName: "BooleanInputGroup__ItemsContainer",
  componentId: "nftamj-1"
})(["display:flex;flex-wrap:wrap;", " > *{margin-right:", ";margin-bottom:10px;}"], directionModifiers, getItemsRightMargin);
/* istanbul ignore next */


var defaultItemRenderer = function defaultItemRenderer() {
  return null;
};

var BooleanInputGroup = function BooleanInputGroup(props) {
  var disabled = props.disabled,
      items = props.items,
      _props$itemRenderer = props.itemRenderer,
      itemRenderer = _props$itemRenderer === void 0 ? defaultItemRenderer : _props$itemRenderer,
      onChange = props.onChange,
      readOnly = props.readOnly,
      size = props.size,
      status = props.status,
      vertical = props.vertical,
      warningMessage = props.warningMessage,
      rest = _objectWithoutProperties(props, ["disabled", "items", "itemRenderer", "onChange", "readOnly", "size", "status", "vertical", "warningMessage"]);

  if (!items || !items.length) {
    return null;
  }

  var hasWarning = status === 'warning' || !!warningMessage;
  return _react.default.createElement(Container, rest, _react.default.createElement(ItemsContainer, {
    isVertical: !!vertical
  }, items.map(function (item, index) {
    return itemRenderer(_objectSpread({}, item, {
      index: index,
      disabled: disabled || item.disabled,
      onChange: onChange,
      readOnly: readOnly || item.readOnly,
      size: size,
      status: hasWarning ? 'warning' : 'normal'
    }));
  })), warningMessage && _react.default.createElement(_Message.default, {
    intent: "warning"
  }, warningMessage));
};

var _default = BooleanInputGroup;
exports.default = _default;